import { RangeTuple, RoomOption } from 'components/filters/types';

export const formatRoomsRange = (i: number): RangeTuple<RoomOption> => {
  if (!i) return null;
  return Number.isInteger(i) ? [ i, null ] : [ Math.floor(i), Math.ceil(i) ];
};
